import { merchantKnowledgeSuggestionViewSchema } from "@redotech/shopper-agent-knowledge-common/suggested-merchant-knowledge-view";
import { suggestedMerchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/**
 * Resolves proposals the caller was pointed at by id, e.g. from a notification.
 * Account-scoped, so ids from another store simply do not come back.
 */
export const getKnowledgeSuggestions = {
  name: "getKnowledgeSuggestions" as const,
  input: z
    .object({ ids: z.array(suggestedMerchantKnowledgeIdFormat.schema).max(50) })
    .strict(),
  output: z.array(merchantKnowledgeSuggestionViewSchema),
};
